// 初始化 state
const state = {
  id: '',
  name: '',
  department: ''
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  // 设置公司信息
  setCompany (state, id, name, dep) {
    state.id = id;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js